/**
 * @fileoverview Carousel funtime.
 */

var $ = require('jquery');
var Hammer = require('hammerjs');
require('bootstrap/js/transition');
require('bootstrap/js/carousel');

/**
 * @param {string} $el
 * @param {Object} cfg
 */
function carousel($el, cfg) {
  cfg = cfg || {};
  var data = {
    interval: cfg.interval ? cfg.interval : false
  };
  $el.carousel(data);

  $el.on('slid.bs.carousel', function(e) {
    cfg.callback && cfg.callback(e);
  });

  if ($el.length) {
    Hammer($el[0]).on('swipeleft', function() {
      $el.carousel('next');
    });

    Hammer($el[0]).on('swiperight', function() {
      $el.carousel('prev');
    });
  }
}

module.exports = carousel;
